import React from 'react';


export const GenericPSA = ({
  crest = null,
  headline = null,
  subheading = null,
  children,
}) => {

  return (
    <section className='vh-100 moa-ff-sans black-70'>
      <div className="pt6 ph3 mw8 center">
        <div className='pt3 lh-copy'>
          {crest}

          <div className="mt3 f1 fw3 lh-title near-black">
            {headline}
          </div>

          {subheading &&
            <div className="mt3 f3 fw3 light-silver">
              {subheading}
            </div>
          }
        </div>

        {children}
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/_system/GenericPSA.js